import { toKebabCase } from '@/modern/utils/transformString'

const FIELDS_DATALAYER_NOT_TO_SANITIZE = [
  'veiculosMaisBuscados',
  'pageName',
  'url',
  'recommendationTimestamp',
  'idcmp',
  'idcmpint',
  'icid',
  'lkid',
  'price',
  'domain',
]

const formatTypeof = {
  object: (prevItem, currentItem) => {
    const [key, value] = currentItem

    const notSanitize = FIELDS_DATALAYER_NOT_TO_SANITIZE.includes(key)
    return {
      ...prevItem,
      [key]: notSanitize ? value : sanitizeObjectValues(value),
    }
  },
  string: (prevItem, currentItem) => {
    const [key, value] = currentItem

    const notSanitize = FIELDS_DATALAYER_NOT_TO_SANITIZE.includes(key)
    return {
      ...prevItem,
      [key]: notSanitize ? value : toKebabCase(value),
    }
  },
}

const sanitizeObjectValues = (obj = {}) => {
  const sanitized = Object.entries(obj).reduce((prevItem, currentItem) => {
    const [key, value] = currentItem

    const formatted = formatTypeof[typeof value]

    return formatted
      ? formatted(prevItem, currentItem)
      : {
          ...prevItem,
          [key]: value,
        }
  }, {})

  return sanitized
}

export { sanitizeObjectValues }
